import {Injectable} from '@angular/core';
import {MissingTranslationHandler, MissingTranslationHandlerParams} from '@ngx-translate/core';

@Injectable({providedIn: 'root'})
export class DebugMissingTranslationHandler implements MissingTranslationHandler {
  private readonly reported = new Set<string>();

  public handle(params: MissingTranslationHandlerParams): string {
    const lang = params.translateService.currentLang ?? params.translateService.defaultLang ?? '?';
    const seenKey = `${lang}:${params.key}`;
    if (!this.reported.has(seenKey)) {
      this.reported.add(seenKey);
      console.debug(`[i18n] missing translation [${lang}]: ${params.key}`);
    }
    return params.key;
  }
}
